import { render, staticRenderFns } from "./manageRemindersEmailSchedule.vue?vue&type=template&id=53b7a2cd&scoped=true"
import script from "./manageRemindersEmailSchedule.vue?vue&type=script&lang=js"
export * from "./manageRemindersEmailSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7a2cd",
  null
  
)

export default component.exports